import { useState, useEffect, useContext } from 'react';
import "../css/Modal.css"
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { scrollToTop } from "../utils/helper.js";
import FetchUtil from "../utils/FetchUtil";
import { ddStyles } from "../utils/CommonStyles.js";

let timezoneOptions = [];
let countryOptions = [];
let stateOptions = [];
let defCountryText = "Select Country";
let operationTypeOptions = [];
let operationAreaOptions = [];
	operationAreaOptions.push({ label: "Facility", value: "Facility" });
	operationAreaOptions.push({ label: "Farm", value: "Farm" });
function WorkLocationModal({ t, companyList, companyId, deptList, departmentKey, location, setShow, refetch, add, modalClosed }) {
	const [states, setStates] = useState([]);
	const [error, setError] = useState("");
	const [formErrors, setFormErrors] = useState([]);
	const [isSubmit, setIsSubmit] = useState(false);
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();
	const [stateSelected, setStateSelected] = useState({ name: "stateKey", label: (location.stateName), value: (location.stateKey + "-" + location.stateCode) });
	const [countrySelected, setCountrySelected] = useState({ name: "countryCode", label: (location.countryName), value: location.countryCode });
	const [timezoneSelected, setTimezoneSelected] = useState({ name: "locationTimeZone", label: (location.locationTimeZone), value: location.locationTimeZone });

	const [countryLoaded, setCountryLoaded] = useState(false);
	const [stateLoaded, setStateLoaded] = useState(false);
	const [timezoneLoaded, setTimezoneLoaded] = useState(false);
	const [companyTypeLoaded, setCompanyTypeLoaded] = useState(false);
	const [operTypeSelected, setOperTypeSelected] = useState({ name: "operationTypeKey", label: (location.operationTypeDesc), value: location.operationTypeKey });
	const [operAreaSelected, setOperAreaSelected] = useState({ name: "operationArea", label: (location.operationArea), value: location.operationArea });
	const submitText = t("page.submit");
	const closeText = t("page.close");
	const [isChecked, setIsChecked] = useState(location.multiProduct);
	const [isUnknownChecked, setIsUnknownChecked] = useState(location.isUnknown);
	const [locationProvisions, setLocationProvisions] = useState([]);
	const [waterSources, setWaterSources] = useState([]);
	const [selectedWaterSources, setSelectedWaterSources] = useState(location.waterSources);
	const [waterEquipClean, setWaterEquipClean] = useState([]);
	const [selectedWaterEquipClean, setSelectedWaterEquipClean] = useState(location.waterEquimentClean);
	const [fruitWash, setFruitWash] = useState([]);
	const [fruitWashKey, setFruitWashKey] = useState(location.waterFruitWashKey);
	const [potableWater, setPotableWater] = useState([]);
	const [potableWaterKey, setPotableWaterKey] = useState(location.potableWaterKey);
	const [wasteTreaments, setWasteTreaments] = useState([]);
	const [wasteTreatmentKey, setWasteTreatmentKey] = useState(location.wasteTreatmentKey);
	const [humanBiosolidUses, setHumanBiosolidUses] = useState([]);
	const [humanBiosolidKey, setHumanBiosolidKey] = useState(location.humanBiosolidKey);
	const [housingDensity, setHousingDensity] = useState([]);
	const [housingDensityKey, setHousingDensityKey] = useState(location.housingDensityKey);
	const [workerRegionalLocations, setWorkerRegionalLocations] = useState([]);
	const [workerNationalityKey, setWorkerNationalityKey] = useState(location.workerNationalityKey);

	const initialValues = {
		companyId: companyId,
		companyName: location.companyName,
		departmentKey: departmentKey,
		locationKey: location.locationKey,
		locationName: location.locationName,
		description: location.description,
		address1: location.address1,
		address2: location.address2,
		phone: location.phone,
		zipCode: location.zipCode,
		zipExt: location.zipExt,
		city: location.city,
		stateKey: location.stateKey,
		stateCode: location.stateCode,
		countryCode: location.countryCode,
		locationTimeZone: location.locationTimeZone,
		geocode: location.geocode,
		latitude: location.latitude,
		longitude: location.longitude,
		operationTypeKey: location.operationTypeKey,
		operationArea: location.operationArea,
		updatedById: userCtx.loggedInUserId,
		HepAVaccRate: location.hepAVaccinationRate,
		isChecked: location.multiProduct,
		isUnknownChecked: location.isUnknown,
	};

	const [formValues, setFormValues] = useState(initialValues);
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	
	useEffect(() => {
		fetchCountries();
		fetchStates();
		fetchCompanyTypes();
		fetchTimezones();
		fetchLocationProvisions();
		initValues();
		scrollToTop();
	}, []);

	const handleClose = (event) => {
		modalClosed();
	};
	
	function initValues() {
		if (add) {
			const selectedDept = deptList.find(department => department.departmentKey == departmentKey);
			if (selectedDept) {
				formValues.address1 = (selectedDept.address1) ? selectedDept.address1 : "";
				formValues.address2 = (selectedDept.address2) ? selectedDept.address2 : "";
				formValues.phone = (selectedDept.phone) ? selectedDept.phone : "";
				formValues.zipCode = (selectedDept.zipCode) ? selectedDept.zipCode : "";
				formValues.zipExt = (selectedDept.zipExt) ? selectedDept.zipExt : "";
				formValues.city = (selectedDept.city) ? selectedDept.city : "";
				formValues.stateKey = (selectedDept.stateKey) ? selectedDept.stateKey : "";
				formValues.countryCode = (selectedDept.countryCode) ? selectedDept.countryCode : "US";
				formValues.stateCode = selectedDept.stateCode;
				formValues.locationTimeZone = selectedDept.companyTimeZone;
				formValues.latitude = selectedDept.latitude;
				formValues.longitude = selectedDept.longitude;
				setCountrySelected({ ...countrySelected, label: (selectedDept.countryName), value: (selectedDept.countryCode) });
				setStateSelected({ ...stateSelected, label: (selectedDept.stateName), value: (selectedDept.stateKey + '-' + selectedDept.stateCode) });
				setTimezoneSelected({ ...timezoneSelected, label: (selectedDept.companyTimeZone), value: (selectedDept.companyTimeZone) });
			} else {
				formValues.address1 = location.address1;
				formValues.address2 = location.address2;
				formValues.phone = location.phone;
				formValues.zipCode = location.zipCode;
				formValues.zipExt = location.zipExt;
				formValues.city = location.city;
				formValues.stateKey = location.stateKey;
				formValues.countryCode = location.countryCode;
				formValues.stateCode = location.stateCode;
				formValues.locationTimeZone = location.locationTimeZone;
				formValues.latitude = location.latitude;
				formValues.longitude = location.longitude;
				setCountrySelected({ ...countrySelected, label: (location.countryName), value: (location.countryCode) });
				setStateSelected({ ...stateSelected, label: (location.stateName), value: (location.stateKey + '-' + location.stateCode) });
				setTimezoneSelected({ ...timezoneSelected, label: (location.locationTimeZone), value: (location.locationTimeZone) });
			}

		}
	}
	function setCountryValues(countryObj) {
		let countryOptionValue = {};
		countryOptions = [];
		if (countryObj && countryObj.length > 0) {
			countryObj.map((country, index) => {
				countryOptionValue.label = country.countryName;
				countryOptionValue.value = country.countryCode;
				countryOptions.push(countryOptionValue);
				countryOptionValue = {};
			});
			setCountryLoaded(true);
		}

	}
	function setStateValues(stateObj, countryCode, defDataLoad) {
		let stateValue = {};
		stateOptions = [];
		stateOptions.push({ label: "", value: "0-" });
		if (stateObj && stateObj.length > 0) {
			stateObj.map((state, index) => {
				if (state.countryCode === countryCode) {
					stateValue.label = state.name;
					stateValue.value = state.stateKey + "-" + state.stateCode;
					stateOptions.push(stateValue);
					stateValue = {};
				}

			});
			setStateLoaded(true);
			if (!defDataLoad) {
				setStateSelected({ ...stateSelected, label: "", value: "0-" });
			}
		}
	}

	function setTimezoneValues(timezoneObj) {
		let timezoneValue = {};
		timezoneOptions = [];
		timezoneOptions.push({ label: "", value: "" });
		if (timezoneObj && timezoneObj.length > 0) {
			timezoneObj.map((timezone, index) => {
				timezoneValue.label = timezone.timezone;
				timezoneValue.value = timezone.timezone;
				timezoneOptions.push(timezoneValue);
				timezoneValue = {};


			});
			setTimezoneLoaded(true);
		}
	}

	function fetchStates() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: true, countryCode: (location.countryCode ? location.countryCode : "US") }),
		};
		try {
			FetchUtil.fetchAPI("MGetAllState", "/Service/StaticHelper/GetAllState", requestOptions, getStatesSuccess, getStatesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getStatesFail(redirect) {
		setError(t("error.getStateFailed"));
	}
	function getStatesSuccess(responseData) {
		let stateResponse;
		if (responseData) {
			stateResponse = responseData.getStateResponse;
			if (stateResponse && stateResponse.errorCode === "0") {
				setStateValues(stateResponse.states, formValues.countryCode, true);
				setStates([...states, ...stateResponse.states]);
			} else if (stateResponse) {
				setError(t("error.error") + " " + stateResponse.errorMessage);
			}
		}
	}
	function fetchCountries() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("MGetCountries", "/Service/StaticHelper/GetCountries", requestOptions, getCountriesSuccess, getCountriesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getCountriesFail(redirect) {
		setError(t("error.getCountryFailed"));
	}
	function getCountriesSuccess(responseData) {
		let countriesResponse;
		if (responseData) {
			countriesResponse = responseData.getCountriesResponse;
			if (countriesResponse && countriesResponse.errorCode === "0") {
				//setCountries([...countries, ...countriesResponse.countries]);
				setCountryValues(countriesResponse.countries);
			} else if (countriesResponse) {
				setError(t("error.error") + " " + countriesResponse.errorMessage);
			}
		}
	}

	function fetchTimezones() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: false }),
		};
		try {
			FetchUtil.fetchAPI("MGetTimeZone", "/Service/StaticHelper/GetTimeZones", requestOptions, getTimezonesSuccess, getTimezonesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getTimezonesFail(redirect) {
		if (redirect) {
			navigate("/");
		}
		setError(t("error.getTimezoneFailed"));
	}

	function getTimezonesSuccess(responseData) {
		let timezoneResponse;
		if (responseData) {
			timezoneResponse = responseData.getTimeZoneResponse;
			if (timezoneResponse && timezoneResponse.errorCode === "0") {
				//setTimezones([...timezones, ...timezoneResponse.timeZones]);
				setTimezoneValues(timezoneResponse.timeZones);
			} else if (timezoneResponse) {
				setError(t("error.error") + " " + timezoneResponse.errorMessage);
			}
		}
	}
	function fetchCompanyTypes() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("MGetAllCompanyTypes", "/Service/StaticHelper/GetCompanyTypes", requestOptions, getCompanyTypesSuccess, getCompanyTypesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getCompanyTypesFail(redirect) {
		setError(t("error.getCompanyTypeFailed"));
	}
	function getCompanyTypesSuccess(responseData) {
		let companyTypesResponse;
		if (responseData) {
			companyTypesResponse = responseData.getCompanyTypesResponse;
			if (companyTypesResponse && companyTypesResponse.errorCode === "0") {
				setOperationTypeValues(companyTypesResponse.companyTypes);
			} else if (companyTypesResponse) {
				setError(t("error.error") + " " + companyTypesResponse.errorMessage);
			}
		}
	}

	function setOperationTypeValues(companyTypeObj) {
		let companyTypeValue = {};
		operationTypeOptions = [];
		operationTypeOptions.push({ label: "", value: 0 });
		if (companyTypeObj && companyTypeObj.length > 0) {
			companyTypeObj.map((aCompanyType, index) => {
				companyTypeValue.label = aCompanyType.description;
				companyTypeValue.value = aCompanyType.companyTypeKey;
				operationTypeOptions.push(companyTypeValue);
				companyTypeValue = {};


			});
			setCompanyTypeLoaded(true);
		}
	}
	function fetchLocationProvisions() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("MGetLocationProvisions", "/Service/StaticHelper/GetLocationProvisions", requestOptions, getLocationProvisionsSuccess, getLocationProvisionsFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getLocationProvisionsFail(redirect) {
		setError(t("error.getLocationProvisionFailed"));
	}
	function getLocationProvisionsSuccess(responseData) {
		let locationProvisionsResponse;
		if (responseData) {
			locationProvisionsResponse = responseData.getLocationProvisionResponse;
			if (locationProvisionsResponse && locationProvisionsResponse.errorCode === "0") {
				setLocationProvisions(locationProvisionsResponse.locationProvisions);
				fetchWaterSource(locationProvisionsResponse.locationProvisions);
				fetchWaterEquipClean(locationProvisionsResponse.locationProvisions);
				fetchFruitWash(locationProvisionsResponse.locationProvisions);
				fetchPotableWater(locationProvisionsResponse.locationProvisions);
				fetchWasteTreatments(locationProvisionsResponse.locationProvisions);
				fetchHumanBiosolidUses(locationProvisionsResponse.locationProvisions);
				fetchHousingDensity(locationProvisionsResponse.locationProvisions);
				fetchWorkerRegionalLocations(locationProvisionsResponse.locationProvisions);
			} else if (locationProvisionsResponse) {
				setError(t("error.error") + " " + locationProvisionsResponse.errorMessage);
			}
		}
	}
	function fetchWaterSource(locationProvisions){
		let waterSourcesArr = [];
		if(locationProvisions && locationProvisions.length > 0){
			locationProvisions.map((alocationProvision, index) => {
				if(alocationProvision.groupName == "Water Source"){
					waterSourcesArr.push(alocationProvision)
				}
			});
			setWaterSources(waterSourcesArr);
		}
	}
	function fetchWaterEquipClean(locationProvisions){
		let waterEquipCleanArr = [];
		if(locationProvisions && locationProvisions.length > 0){
			locationProvisions.map((alocationProvision, index) => {
				if(alocationProvision.groupName == "Water Equipment Cleaning"){
					waterEquipCleanArr.push(alocationProvision)
				}
			});
			setWaterEquipClean(waterEquipCleanArr);
		}
	}
	function fetchFruitWash(locationProvisions){
		let fruitWashArr = [];
		if(locationProvisions && locationProvisions.length > 0){
			locationProvisions.map((alocationProvision, index) => {
				if(alocationProvision.groupName == "Water Fruit Cleaning"){
					fruitWashArr.push(alocationProvision)
				}
			});
			setFruitWash(fruitWashArr);
		}
	}
	function fetchPotableWater(locationProvisions){
		let potableWaterArr = [];
		if(locationProvisions && locationProvisions.length > 0){
			locationProvisions.map((alocationProvision, index) => {
				if(alocationProvision.groupName == "Water Potable"){
					potableWaterArr.push(alocationProvision)
				}
			});
			setPotableWater(potableWaterArr);
		}
	}
	function fetchWasteTreatments(locationProvisions){
		let wasteTreatmentArr = [];
		if(locationProvisions && locationProvisions.length > 0){
			locationProvisions.map((alocationProvision, index) => {
				if(alocationProvision.groupName == "Waste treatment"){
					wasteTreatmentArr.push(alocationProvision)
				}
			});
			setWasteTreaments(wasteTreatmentArr);
		}
	}
	function fetchHumanBiosolidUses(locationProvisions){
		let humanBiosolidArr = [];
		if(locationProvisions && locationProvisions.length > 0){
			locationProvisions.map((alocationProvision, index) => {
				if(alocationProvision.groupName == "Human Biosolid Use"){
					humanBiosolidArr.push(alocationProvision)
				}
			});
			setHumanBiosolidUses(humanBiosolidArr);
		}
	}
	function fetchHousingDensity(locationProvisions){
		let housingDensityArr = [];
		if(locationProvisions && locationProvisions.length > 0){
			locationProvisions.map((alocationProvision, index) => {
				if(alocationProvision.groupName == "Housing Density"){
					housingDensityArr.push(alocationProvision)
				}
			});
			setHousingDensity(housingDensityArr);
		}
	}
	function fetchWorkerRegionalLocations(locationProvisions){
		let workerRegionalLocations = [];
		if(locationProvisions && locationProvisions.length > 0){
			locationProvisions.map((alocationProvision, index) => {
				if(alocationProvision.groupName == "Worker Nationality"){
					workerRegionalLocations.push(alocationProvision)
				}
			});
			setWorkerRegionalLocations(workerRegionalLocations);
		}
	}
	const multiProductHandler =() => {
		setIsChecked(!isChecked);
	}
	
	const unknownHandler = () => {
		setIsUnknownChecked((isUnknownChecked == 1) ? 0 : 1);
		if(isUnknownChecked == 1){
			formValues.HepAVaccRate = "";
		}
	}
	const waterSourceHandler =(e) =>{
		const { value, checked } = e.target;
		let selWaterSourceObj = {waterSourceKey: "", waterSourceValue: ""};
		let waterSourceObj = {locationProvisionKey: "", groupValue: ""};
		let filteredArray;
		if (checked) {
			waterSourceObj = waterSources.find(selValue => selValue.locationProvisionKey == parseInt(value))
			selWaterSourceObj = {waterSourceKey: waterSourceObj.locationProvisionKey, waterSourceValue:waterSourceObj.groupValue };
            setSelectedWaterSources([...selectedWaterSources, selWaterSourceObj]);
        } else {
			filteredArray = selectedWaterSources.filter(selWaterSource => selWaterSource.waterSourceKey !== parseInt(value));
    		setSelectedWaterSources(filteredArray);
		}
		//printSelectedWaterSources();
	}
	/*function printSelectedWaterSources(){
		selectedWaterSources.map((selectedWaterSourceObj) => {
			console.log(selectedWaterSourceObj.waterSourceKey + " " + selectedWaterSourceObj.waterSourceValue);
		});
	}*/
	const waterEquipCleanHandler =(e) =>{
		const { value, checked } = e.target;
		let selWaterEquipCleanObj = {waterEquipCleanKey: "", waterEquipCleanValue: ""};
		let waterEquipCleanObj = {locationProvisionKey: "", groupValue: ""};
		let filteredArray;
		if (checked) {
			waterEquipCleanObj = waterEquipClean.find(selValue => selValue.locationProvisionKey == parseInt(value))
			selWaterEquipCleanObj = {waterEquipCleanKey: waterEquipCleanObj.locationProvisionKey, waterEquipCleanValue:waterEquipCleanObj.groupValue };
            setSelectedWaterEquipClean([...selectedWaterEquipClean, selWaterEquipCleanObj]);
        } else {
			filteredArray = selectedWaterEquipClean.filter(selWaterEquipClean => selWaterEquipClean.waterEquipCleanKey !== parseInt(value));
    		setSelectedWaterEquipClean(filteredArray);
		}
	}
	const radioSelectHandler =(e) =>{
		const {name, value} = e.target;
		switch(name){
			case "fruitWash" : setFruitWashKey(value);
								break;
			case "potableWater" : setPotableWaterKey(value);
								break;
			case "wasteTreatment" : setWasteTreatmentKey(value);
								break;
			case "humanBiosolidUse" : setHumanBiosolidKey(value);
								break;
			case "housingDensity" : setHousingDensityKey(value);
								break;
			case "workerNationality" : setWorkerNationalityKey(value);
								break;
		}
	}
	const valueHandler = (e) => {
		const { name, value } = e.target;
		if (typeof value === 'undefined') {
			value = "";
		}
		if(name == "isUnknown"){
			if(isUnknownChecked == 1){
				formValues.HepAVaccRate = "";
			}
		}
		setFormValues({ ...formValues, [name]: value });
	}

	const countryHandler = (selectedOption, action) => {
		let countryCode = selectedOption ? selectedOption.value : "";
		let countryName = selectedOption ? selectedOption.label : "";
		formValues.countryCode = countryCode;
		setCountrySelected({ ...countrySelected, label: (countryName), value: countryCode });
		setStateValues(states, countryCode, false);
	}

	const stateHandler = (selectedOption, action) => {
		let state = selectedOption ? selectedOption.value : "";
		let stateName = selectedOption ? selectedOption.label : "";
		setStateSelected({ ...stateSelected, label: (stateName), value: state });
		if (state) {
			let stateArr = state.split("-");
			formValues.stateKey = stateArr[0];
			formValues.stateCode = stateArr[1];
		}
	}

	const timezoneHandler = (selectedOption, action) => {
		let timezoneCode = selectedOption ? selectedOption.value : "";
		let timezoneName = selectedOption ? selectedOption.label : "";
		formValues.locationTimeZone = timezoneCode;
		setTimezoneSelected({ ...timezoneSelected, label: (timezoneName), value: timezoneCode });
	}

	const operTypeHandler = (selectedOption, action) => {
		let operationTypeKey = selectedOption ? selectedOption.value : 0;
		let operationTypeDesc = selectedOption ? selectedOption.label : "";
		formValues.operationTypeKey = operationTypeKey;
		setOperTypeSelected({ ...operTypeSelected, label: operationTypeDesc, value: operationTypeKey });
	}

	const operAreaHandler = (selectedOption, action) => {
		let operationArea = selectedOption ? selectedOption.label : "";
		formValues.operationArea = operationArea;
		setOperAreaSelected({ ...operAreaSelected, label: operationArea, value: operationArea });
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		setIsSubmit(true);
		const formData = new FormData(event.currentTarget);
		for (let entry of formData.entries()) {
			if (entry[0] == "stateKey") {
				let stateArr = entry[1].split("-");
				formValues[entry[0]] = stateArr[0];
				formValues.stateCode = stateArr[1];

			} else {
				formValues[entry[0]] = entry[1];
			}
		}


		let errors = validateFields();
		setFormErrors(errors);
		if (!errors || errors.length === 0) {
			updateWorkLocation();
		} else {
			setIsSubmit(false);
		}

	};
	const validateFields = () => {
		const errors = [];
		if (add) {

		}

		if (!formValues.locationName) {
			errors.push(t("error.locNameReqd"));
		}
		if (!formValues.stateKey || formValues.stateKey === 0) {
			errors.push(t("error.stateReqd"));
		}
		if (!formValues.operationTypeKey || formValues.operationTypeKey === 0) {
			errors.push(t("error.operTypeReqd"));
		}
		if (!formValues.operationArea) {
			errors.push(t("error.operAreaReqd"));
		}
		if(formValues.HepAVaccRate && !formValues.HepAVaccRate.match("\\d*\\.?\\d+")){
			errors.push(t("error.hepA.float"));
		}
		return errors;
	};
	const updateWorkLocation = () => {
		let action = 2;
		let locationKey = location.locationKey;
		if (add) {
			action = 1;
			locationKey = 0;
		}
		let serverParams = {
			source: "web",
			action: action,
			updatedById: formValues.updatedById,
			companyId: companyId,
			departmentKey: departmentKey,
			locationKey: locationKey,
			locationName: formValues.locationName.trim(),
			description: formValues.description.trim(),
			address1: (formValues.address1) ? formValues.address1.trim() : '',
			address2: (formValues.address2) ? formValues.address2.trim() : '',
			phone: (formValues.phone) ? formValues.phone.trim() : '',
			zipCode: (formValues.zipCode) ? formValues.zipCode.trim() : '',
			zipExt: (formValues.zipExt) ? formValues.zipExt.trim() : '',
			city: (formValues.city) ? formValues.city.trim() : '',
			stateKey: formValues.stateKey,
			stateCode: formValues.stateCode.trim(),
			countryCode: formValues.countryCode,
			locationTimeZone: formValues.locationTimeZone,
			latitude: (formValues.latitude) ? formValues.latitude.trim() : '',
			longitude: (formValues.longitude) ? formValues.longitude.trim() : '',
			operationTypeKey: formValues.operationTypeKey,
			operationArea: formValues.operationArea,
			multiProduct: (isChecked)?1:0,
			isUnknown:(isUnknownChecked)?1:0,
			hepAVaccinationRate:formValues.HepAVaccRate,
			waterSources:selectedWaterSources,
			waterEquimentClean:selectedWaterEquipClean,
			waterFruitWashKey:fruitWashKey,
			potableWaterKey:potableWaterKey,
			wasteTreatmentKey:wasteTreatmentKey,
			humanBiosolidKey:humanBiosolidKey,
			housingDensityKey:housingDensityKey,
			workerNationalityKey:workerNationalityKey,
		};
		//console.log(JSON.stringify(serverParams));
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("UpdateLocation", "/Service/CompanyService/AddUpdateWorkLocation", requestOptions, updateWorkLocationSuccess, updateWorkLocationFail);
		} catch (error) {
			setError(error.message);
		}
	};

	function updateWorkLocationFail(redirect) {
		setIsSubmit(false);
		setError(t("error.locEditFailed"));
	}
	function updateWorkLocationSuccess(responseData) {
		setIsSubmit(false);
		let addUpdateWorkLocationResponse;
		if (responseData) {
			addUpdateWorkLocationResponse = responseData.addUpdateWorkLocationResponse;
			if (addUpdateWorkLocationResponse) {
				if (addUpdateWorkLocationResponse.errorCode === "0") {
					handleClose();
					refetch();
					navigate("/pages/locations");
				} else {
					setError(t("error.error") + " " +
						addUpdateWorkLocationResponse.errorMessage
					);
				}
			}
		}
	}

	return (
		<>
		{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
		<div className="modalContainer hide-scrollbar">
			<div className="row">
				<div className="col mt-3">
					{((formErrors && formErrors.length > 0) || error) ? (
						<div id="inerrorMessage" className="errorblock">
							{((formErrors && formErrors.length > 0)) ? (
								formErrors.map((errorData, index) => (
									<p className="message-line">{errorData}</p>
								))
							) : ""}
							{error}
						</div>
					) : (<></>)}
				</div>
			</div>
			<div className="row">
				<div className="col">
					<form
						className="regn_form_container"
						acceptCharset="UTF-8"
						id="sign-up"
						onSubmit={handleSubmit}
					>
						<h2>{(add) ? t("page.loc.add") : t("page.loc.edit")}
						</h2>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label htmlFor="locationName" className="form-label">
										<span className="form_required">*</span>
										{t("page.loc.name")}
									</label>

									<input
										type="text"
										name="locationName"
										id="locationName"
										placeholder="Name"
										maxLength="50"
										value={formValues.locationName}
										onChange={(e) => valueHandler(e)}
										className="form-control rounded-pill border-0 shadow-sm px-4"
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label htmlFor="description" className="form-label">
										{t("page.description")}
									</label>

									<input
										type="text"
										name="description"
										id="description"
										placeholder=""
										maxLength="100"
										value={formValues.description}
										onChange={(e) => valueHandler(e)}
										className="form-control rounded-pill border-0 shadow-sm px-4"
									/>
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.oper.type")}
									</label>
									<Select
										name="operationTypeKey"
										options={operationTypeOptions}
										onChange={operTypeHandler}
										placeholder={""}
										value={operTypeSelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="operationTypeKey-input"
										styles={ddStyles}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.oper.area")}
									</label>
									<Select
										name="operationArea"
										options={operationAreaOptions}
										onChange={operAreaHandler}
										placeholder={""}
										value={operAreaSelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="operationArea-input"
										styles={ddStyles}
									/>
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.timezone")}
									</label>
									<Select
										name="locationTimeZone"
										options={timezoneOptions}
										onChange={timezoneHandler}
										placeholder={""}
										value={timezoneSelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="locationTimeZone-input"
										styles={ddStyles}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.country")}
									</label>
									<Select
										name="countryCode"
										options={countryOptions}
										onChange={countryHandler}
										placeholder={defCountryText}
										value={countrySelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="countryCode-input"
										styles={ddStyles}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.address1")}
									</label>
									<input name="address1" value={formValues.address1} maxlength="40"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.address2")}
									</label>
									<input name="address2" value={formValues.address2} maxlength="40"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.city")}
									</label>
									<input name="city" value={formValues.city} maxlength="40"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.state")}
									</label>
									<Select
										name="stateKey"
										options={stateOptions}
										onChange={stateHandler}
										placeholder={""}
										value={stateSelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="stateKey-input"
										styles={ddStyles}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-xs-2 col-3">
								<div className="form-group">
									<label className="form-label">
										{t("page.zipCode")}
									</label><input name="zipCode" value={formValues.zipCode}
										maxlength="12"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col-xs-2 col-3">
								<div className="form-group">
									<label className="form-label">
										{t("page.zipExt")}
									</label>
									<input name="zipExt" value={formValues.zipExt}
										maxlength="4"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.phone")}
									</label>
									<input name="phone" value={formValues.phone}
										maxlength="15" className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.latitude")}
									</label><input name="latitude" value={formValues.latitude}
										maxlength="13"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.longitude")}
									</label>
									<input name="longitude" value={formValues.longitude}
										maxlength="13"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.multi.product")}&nbsp;&nbsp;<input name="multiProduct" type="checkbox" checked={isChecked} onChange={() => multiProductHandler()}  />
									</label> 
									
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.HepA.vaccination")}
									</label>
									<span style={{fontSize:'15px'}}>
										{t("page.unknown")}&nbsp;&nbsp;<input name="isUnknown" type="checkbox" checked={(isUnknownChecked == 1)?true:false} onChange={() => unknownHandler()} />
									</span>
									<br />
									<span style={{fontSize:'15px'}}>
										{t("page.HepA.vaccination.rate")}&nbsp;&nbsp;
									<input name="HepAVaccRate" value={(isUnknownChecked == 1)? '' : formValues.HepAVaccRate}
										maxlength="6"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										readOnly={(isUnknownChecked == 1)?true:false}
										onChange={(e) => valueHandler(e)} />
									</span>
								</div>
							</div>
						</div>
						{(waterSources && waterSources.length > 0)  ? (
						<>
							<br></br>
							<div className="row">
								<div className="col">
									<div className="form-group">
										<label className="form-label">
											{t("page.water.source")}
										</label> 
									</div>
								</div>
							</div>
							<div className="row">
							{waterSources.map((waterSource, index) => (
									<div className="col">
										<div className="form-group">
											<span style={{fontSize:'15px'}}>
												{waterSource.groupValue}&nbsp;&nbsp;<input type="checkbox" value={waterSource.locationProvisionKey} 
												checked={selectedWaterSources.some(selValue => selValue.waterSourceKey == waterSource.locationProvisionKey)} 
												onChange={(e) => waterSourceHandler(e)} />
											</span> 
										</div>
									</div>
								))
							}
							</div>
						</>
						) : (<></>)}
						{(waterEquipClean && waterEquipClean.length > 0)  ? (
						<>
							<br></br>
							<div className="row">
								<div className="col">
									<div className="form-group">
										<label className="form-label">
											{t("page.water.equip.clean")}
										</label> 
									</div>
								</div>
							</div>
							<div className="row">
							{waterEquipClean.map((waterEquipCleanObj, index) => (
									<div className="col">
										<div className="form-group">
											<span style={{fontSize:'15px'}}>
												{waterEquipCleanObj.groupValue}&nbsp;&nbsp;<input type="checkbox" value={waterEquipCleanObj.locationProvisionKey} 
												checked={selectedWaterEquipClean.some(selValue => selValue.waterEquipCleanKey == waterEquipCleanObj.locationProvisionKey)} 
												onChange={(e) => waterEquipCleanHandler(e)} />
											</span> 
										</div>
									</div>
								))
							}
							</div>
						</>
						) : (<></>)}
						<br></br>
						<div className="row">
							{(fruitWash && fruitWash.length > 0)  ? (
								<div className="col">
									<div className="form-group">
										<label className="form-label">
											{t("page.water.fruit.clean")}
										</label> 
										{fruitWash.map((fruitWashObj, index) => (
											<>
											<span style={{fontSize:'15px'}}>
												{fruitWashObj.groupValue}&nbsp;&nbsp;
												<input type="radio" 
												name="fruitWash"
												value={fruitWashObj.locationProvisionKey} 
												checked={fruitWashKey == fruitWashObj.locationProvisionKey} 
												onChange={(e) => radioSelectHandler(e)} />
											</span><br />
											</>
										))
										}
									</div>
								</div>) :  (<></>)}
							{(potableWater && potableWater.length > 0)  ? (
								<div className="col">
									<div className="form-group">
										<label className="form-label">
											{t("page.water.potable")}
										</label> 
										{potableWater.map((potableWaterObj, index) => (
											<>
											<span style={{fontSize:'15px'}}>
												{potableWaterObj.groupValue}&nbsp;&nbsp;
												<input type="radio" 
												name="potableWater"
												value={potableWaterObj.locationProvisionKey} 
												checked={potableWaterKey == potableWaterObj.locationProvisionKey} 
												onChange={(e) => radioSelectHandler(e)} />
											</span><br />
											</> 
										))
										}
									</div>
								</div>) :  (<></>)}
						</div>
						<br></br>
						<div className="row">
							{(wasteTreaments && wasteTreaments.length > 0)  ? (
								<div className="col">
									<div className="form-group">
										<label className="form-label">
											{t("page.waste.treatment")}
										</label> 
										{wasteTreaments.map((wasteTreament, index) => (
											<>
											<span style={{fontSize:'15px'}}>
												{wasteTreament.groupValue}&nbsp;&nbsp;
												<input type="radio" 
												name="wasteTreatment"
												value={wasteTreament.locationProvisionKey} 
												checked={wasteTreatmentKey == wasteTreament.locationProvisionKey} 
												onChange={(e) => radioSelectHandler(e)} />
											</span><br />
											</>
										))
										}
									</div>
								</div>) :  (<></>)}
							{(humanBiosolidUses && humanBiosolidUses.length > 0)  ? (
								<div className="col">
									<div className="form-group">
										<label className="form-label">
											{t("page.human.biosolid.use")}
										</label> 
										{humanBiosolidUses.map((humanBiosolidUse, index) => (
											<>
											<span style={{fontSize:'15px'}}>
												{humanBiosolidUse.groupValue}&nbsp;&nbsp;
												<input type="radio" 
												name="humanBiosolidUse"
												value={humanBiosolidUse.locationProvisionKey} 
												checked={humanBiosolidKey == humanBiosolidUse.locationProvisionKey} 
												onChange={(e) => radioSelectHandler(e)} />
											</span><br />
											</>
										))
										}
									</div>
								</div>) :  (<></>)}
						</div>
						<br></br>
						<div className="row">
							{(housingDensity && housingDensity.length > 0)  ? (
								<div className="col">
									<div className="form-group">
										<label className="form-label">
											{t("page.housing.density")}
										</label> 
										{housingDensity.map((housingDensityObj, index) => (
											<>
											<span style={{fontSize:'15px'}}>
												{housingDensityObj.groupValue}&nbsp;&nbsp;
												<input type="radio" 
												name="housingDensity"
												value={housingDensityObj.locationProvisionKey} 
												checked={housingDensityKey == housingDensityObj.locationProvisionKey} 
												onChange={(e) => radioSelectHandler(e)} />
											</span><br />
											</>
										))
										}
									</div>
								</div>) :  (<></>)}
							{(workerRegionalLocations && workerRegionalLocations.length > 0)  ? (
								<div className="col">
									<div className="form-group">
										<label className="form-label">
											{t("page.worker.regional.location")}
										</label> 
										{workerRegionalLocations.map((workerRegionalLocation, index) => (
											<>
											<span style={{fontSize:'15px'}}>
												{workerRegionalLocation.groupValue}&nbsp;&nbsp;
												<input type="radio" 
												name="workerNationality"
												value={workerRegionalLocation.locationProvisionKey} 
												checked={workerNationalityKey == workerRegionalLocation.locationProvisionKey} 
												onChange={(e) => radioSelectHandler(e)} />
											</span><br />
											</>
										))
										}
									</div>
								</div>) :  (<></>)}
						</div>
						<div className="footer">
							<input
								type="button"
								name="edit-work-loc-close"
								id="edit-work-loc-close"
								className="btn btn-secondary btn-block" data-dismiss="modal"
								disabled={isSubmit}
								onClick={(e) => handleClose(e)}
								style={{ marginRight: "50px" }}
								value={closeText}
							></input>

							<div id="submit-spinner"
								className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
							>  </div>
							<input
								type="submit"
								name="edit-submit"
								id="edit-submit"
								data-dismiss="modal"
								className={"btn btn-primary btn-block"}
								style={{ marginTop: "10px", marginBottom: "10px" }}
								value={submitText}
								disabled={isSubmit}
							>
							</input>

						</div>
					</form>
				</div>
			</div>
			<div className="row">
				<div className="col mt-3">
					{((formErrors && formErrors.length > 0) || error) ? (
						<div id="berrorMessage" className="errorblock">
							{((formErrors && formErrors.length > 0)) ? (
								formErrors.map((errorData, index) => (
									<p className="message-line">{errorData}</p>
								))
							) : ""}
							{error}
						</div>
					) : (<></>)}
				</div>
			</div>
			<div className="row">
				<div className="col">
					<div id="placeholder_1" className="placeholder-pg" style={{ height: "10px" }}></div>
				</div>
			</div>
		</div>
		: null}
		</>
	);
}

export default WorkLocationModal;